/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import { BASE_URL, IMAGE_PATHS, VIDEO_PATHS } from '../../../../constants/paths.constants';
import { universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  container: {
    width: 'calc(100% + 125px)',
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 30,
  },
  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  rightColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  topImage: {
    width: '85%',
    margin: 5,
  },
  leftImage: {
    width: '65%',
    boxShadow: '6px 6px 10px #9E9E9E',
    margin: 5,
  },
  rightImage: {
    width: '62%',
    boxShadow: '6px 6px 10px #9E9E9E',
    margin: 5,
  },
  imageTextTop: {
    fontSize: 14,
    textAlign: 'center',
    marginLeft: -200,
    paddingTop: 15,
    paddingLeft: 100,
  },
  row: {
    marginLeft: 40,
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 30,
  },
  scanImages: {
    width: '100%',
    boxShadow: '6px 6px 10px #9E9E9E',
    margin: 5,
    marginBottom: 15,
  },
  imageColumn: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0 8px 0 0',
  },
  imageText: {
    paddingLeft: 10,
    fontSize: 14,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  petImage: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  fusedImage: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  ctImage: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  text: {
    marginTop: -15,
    paddingBottom: 25,
    fontStyle: 'italic',
  },
  video: {
    width: 'calc(100% + 125px)',
    maxHeight: 435,
    aspectRatio: '.48',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    height: '100%',
    paddingBottom: 30,
  },
}));

const AdditionalCaseStudyImaging02 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <Typography variant="body1" className={classes.text}>
        POSLUMA Images
      </Typography>
      <div className={classes.video}>
        <ReactPlayer className={classes.responsiveVideo} url={VIDEO_PATHS.ACS_2.path} controls />
      </div>
      <Typography variant="body1" className={classes.text}>
        Pelvic Lymph Nodes
      </Typography>
      <div className={classes.container}>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            PET
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_PET.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_PET.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            FUSED
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_FUS.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_FUS.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            CT
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_CT.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_CT.alt}
          />
        </div>
      </div>
      <Typography variant="body1" className={classes.text}>
        Multifocal Primary Prostate Cancer
      </Typography>
      <div className={classes.container}>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            PET
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_PET2.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_PET2.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            FUSED
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_FUS2.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_FUS2.alt}
          />
        </div>
        <div className={classes.imageColumn}>
          <Typography variant="body1" className={classes.imageText}>
            CT
          </Typography>
          <img
            className={classes.scanImages}
            src={`${BASE_URL}${IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_CT2.path}`}
            alt={IMAGE_PATHS.ADDITIONAL_CASE_STUDIES[2].AXIAL_CT2.alt}
          />
        </div>
      </div>
    </>
  );
};

export default AdditionalCaseStudyImaging02;
